module.exports = __webpack_public_path__ + "img/52d2e8e.svg";